/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Morceau de message riche : concaténer les segments dans l'ordre. type=text -> texte plat ; type=link -> lien cliquable (text est déjà le libellé humain, rien à résoudre). Un entityType inconnu doit être rendu en texte simple (extensible sans casse).
 * 
 * @export
 * @interface ActivityMessageSegmentDto
 */
export interface ActivityMessageSegmentDto {
    /**
     * text | link
     * @type {string}
     * @memberof ActivityMessageSegmentDto
     */
    type: string;
    /**
     * Texte à afficher (libellé humain pour un lien)
     * @type {string}
     * @memberof ActivityMessageSegmentDto
     */
    text: string;
    /**
     * Pour type=link : RisqueAssure | Devis | Contrat | Personne | Locataire | Garant | Emprunteur | BienImmobilier | Note | Document | Mandat | CompteBancaire | ProjetEmprunt | Pret (extensible)
     * 
     * @type {string}
     * @memberof ActivityMessageSegmentDto
     */
    entityType?: string | null;
    /**
     * Pour type=link, id de l'entité cible
     * @type {string}
     * @memberof ActivityMessageSegmentDto
     */
    entityId?: string | null;
}

/**
 * Check if a given object implements the ActivityMessageSegmentDto interface.
 */
export function instanceOfActivityMessageSegmentDto(value: object): value is ActivityMessageSegmentDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function ActivityMessageSegmentDtoFromJSON(json: any): ActivityMessageSegmentDto {
    return ActivityMessageSegmentDtoFromJSONTyped(json, false);
}

export function ActivityMessageSegmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityMessageSegmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'text': json['text'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
    };
}

export function ActivityMessageSegmentDtoToJSON(json: any): ActivityMessageSegmentDto {
    return ActivityMessageSegmentDtoToJSONTyped(json, false);
}

export function ActivityMessageSegmentDtoToJSONTyped(value?: ActivityMessageSegmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'text': value['text'],
        'entityType': value['entityType'],
        'entityId': value['entityId'],
    };
}

